import cn from 'classnames';
import { memo } from 'react';

import { useInput } from '@app/components/Input/hooks/useInput';
import { inputTheme } from '@app/components/Input/styles/theme';
import type { Props } from '@app/components/Input/types';
import { Text } from '@app/components/Text';

import type { FC } from 'react';

import '@app/components/Input/styles/Input.desktop.scss';

export const Input: FC<Props> = memo((props) => {
  const {
    wrapperClassname = '',
    containerClassname = '',
    inputClassname = '',
    labelClassname = '',
    descriptionClassname = '',
    wrapperStyle,
    containerStyle,
    inputStyle,
    labelStyle,
    descriptionStyle,
    description = '',
    labelPattern = 'body1',
    id = '',
    pattern = '',
    placeholder = '',
    postfix = <></>,
    prefix = <></>,
    label = '',
    value = '',
    onChange,
    readOnly = false,
    disabled = false,
    type = 'text',
    step,
    max,
    min,
    borderRadius = '8px',
    status = 'default',
    autoComplete = 'off',
    name = '',
    dataTestId,
  } = props;

  const {
    state,
    cursor,
    padding,
    inputRef,
    onMouseEnter,
    onMouseLeave,
    handleFocus,
    handleBlur,
  } = useInput(props);

  return (
    <div
      className={cn('ui-input-wrapper', wrapperClassname)}
      style={wrapperStyle}
    >
      {!!label && (
        <Text
          pattern={labelPattern}
          className={cn('ui-input-label', labelClassname)}
          style={labelStyle}
        >
          {label}
        </Text>
      )}
      <div
        className={cn(containerClassname, 'ui-input-container')}
        style={{
          borderRadius,
          boxShadow: inputTheme[state].shadow,
          border: `1px solid ${inputTheme[state].border}`,
          backgroundColor: inputTheme[state].background,
          padding,
          ...containerStyle,
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={handleFocus}
      >
        {prefix}
        <input
          name={name}
          ref={inputRef}
          id={id}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          className={cn('ui-input', inputClassname)}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          type={type}
          autoComplete={autoComplete}
          step={step}
          min={min}
          max={max}
          style={{
            cursor,
            color: inputTheme[state].text,
            ...inputStyle,
          }}
          {...(pattern ? { pattern } : {})}
          {...(dataTestId ? { 'data-testid': dataTestId } : {})}
        />
        {postfix}
      </div>
      {!!description && (
        <Text
          pattern="body2"
          className={cn('ui-input-description', descriptionClassname)}
          data-testid="mobile-alert"
          style={{
            color:
              status === 'error'
                ? '#E14F4F'
                : status === 'warning'
                ? '#F0AD4E'
                : '#373A3C',
            ...descriptionStyle,
          }}
        >
          {description}
        </Text>
      )}
    </div>
  );
});
